import indexZh from "./zh-CN/indexZh";

export default {
  ...indexZh,
};



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN.js